import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import RestartIcon from '@material-ui/icons/Replay';

import logo from '../images/logo.png';

import styles from '../styles/MenuBar.module.css';

interface Props {
  levelNumber: number;
  undo(): void;
  redo(): void;
  restart(levelNumber: number): void;
  hasUndo: boolean;
  hasRedo: boolean;
  hasRestart: boolean;
}

class MenuBar extends Component<Props> {
  render() {
    return (
      <div className={styles.menuBar}>
        <div className={styles.left}>
          <img
            className={styles.logo}
            src={logo}
            alt="Linearity"
            draggable={false}
          />
        </div>
        <div className={styles.right}>
          <div className={styles.actions}>
            <IconButton
              aria-label="Undo"
              disabled={!this.props.hasUndo}
              onClick={this.props.undo}
              color="secondary"
            >
              <UndoIcon />
            </IconButton>
            <IconButton
              aria-label="Redo"
              disabled={!this.props.hasRedo}
              onClick={this.props.redo}
              color="secondary"
            >
              <RedoIcon />
            </IconButton>
            <IconButton
              aria-label="Restart"
              disabled={!this.props.hasRestart}
              onClick={() => this.props.restart(this.props.levelNumber)}
              color="secondary"
            >
              <RestartIcon />
            </IconButton>
          </div>
        </div>
      </div>
    );
  }
}

export default MenuBar;
